module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-1.jpg?212c96fc2a664991e76f8e210f7c7bd8";